import { lazy } from 'react';

export const LazyDropboxConnectPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--dropbox-connect-page" */ './dropbox-connect-page'
    ),
);
